export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EventCard.vue?vue&type=template&id=11b19b05"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EventCard.vue?vue&type=template&id=11b19b05
// module id = 371
// module chunks = 0